export const CARDS_BLOCK_08 = {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "#FAFAFA",
    "padding": "120px 20px 120px 20px"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#333333",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company:",
      "styleProps": {
        "color": "#333333",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      }
    }
  ],
  "cardElements": [
    {
      "type": "text",
      "id": 1746531362022,
      "elIndex": 0,
      "text": "[[role]]",
      "location": "B",
      "params": [
        {
          "value": "role",
          "label": "role"
        }
      ],
      "styleProps": {
        "margin": "10px 0px 0px 0px",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "color": "#a3a3a3",
        "font-weight": "400"
      },
      "stylePropsTab": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "0.875rem",
        "line-height": "1.25rem",
        "margin": "1px 0px 0px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746529638292,
      "elIndex": 1,
      "text": "[[name]]",
      "location": "B",
      "params": [
        {
          "value": "name",
          "label": "name"
        }
      ],
      "styleProps": {
        "color": "#333333",
        "font-size": "3rem",
        "line-height": "1",
        "font-weight": "400",
        "margin": "20px 0px 0px 0px"
      },
      "stylePropsTab": {
        "font-size": "2.25rem",
        "line-height": "2.5rem",
        "margin": "10px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "margin": "0px 0px 0px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746547347956,
      "elIndex": 2,
      "text": "[[status ]]",
      "location": "C",
      "params": [
        {
          "value": "status",
          "label": "status "
        }
      ],
      "styleProps": {
        "color": "#808080",
        "font-weight": "700",
        "background-color": "#fafafa",
        "padding": "4px 8px 4px 8px",
        "border-radius": "0.75rem",
        "font-size": "1rem",
        "line-height": "1.5rem"
      },
      "stylePropsTab": {
        "font-size": "0.875rem",
        "line-height": "1.25rem"
      },
      "stylePropsMob": {
        "font-size": "0.875rem",
        "line-height": "1.25rem"
      }
    },
    {
      "type": "text",
      "id": 1746548627463,
      "elIndex": 3,
      "text": "[[description]]",
      "location": "B",
      "params": [
        {
          "value": "description",
          "label": "description"
        }
      ],
      "styleProps": {
        "color": "#808080",
        "margin": "20px 0px 0px 0px",
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      },
      "stylePropsTab": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      }
    }
  ],
  "cardConfig": {
    "perRow": {
      "mobile": 1,
      "tab": 1,
      "desktop": 1
    },
    "layout": "l1",
    "cardstyleProps": {
      "padding": "80px 10px 10px 10px"
    },
    "cardstylePropsMob": {
      "padding": "40px 0px 10px 0px"
    },
    "cardstylePropsTab": {
      "padding": "60px 10px 10px 10px"
    },
    "alternate": true
  },
  "configs": {
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1746623754561
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066"
  },
  "metaDataId": 1746546999697,
  "afterIndex": 1,
  "blockId": 1746546999697,
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "cardLocations": [
    {
      "name": "outer",
      "styleProps": {
        "background-image": "url('')",
        "border-radius": "1rem",
        "padding": "0px 0px 0px 0px",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-color": "#ffffff",
        "box-shadow": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        "width": "70%",
        "margin": "0px auto 0px auto"
      },
      "stylePropsTab": {
        "border-radius": "1rem",
        "width": "auto"
      },
      "stylePropsMob": {
        "border-radius": "0.75rem",
        "width": "auto"
      }
    },
    {
      "name": 0
    },
    {
      "name": "A",
      "styleProps": {
        "background-color": "#ffffff",
        "margin": "0px 0px 0px 0px",
        "border-radius": "0.75rem",
        "padding": "00px 26px 20px 26px",
        "box-shadow": "",
        "alignItems": "center",
        "justify-content": "center",
        "flex-direction": "column",
        "display": "flex",
        "width": "60%",
        "text-align": "center",
        "background-image": "url('[[img]]')",
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "cover"
      },
      "innerDiv": {
        "styleProps": {
          "height": "448px"
        },
        "stylePropsTab": {
          "height": "384px"
        },
        "stylePropsMob": {
          "height": "256px"
        }
      },
      "stylePropsMob": {
        "padding": "0px 0px 0px 0px",
        "width": "100%"
      }
    },
    {
      "name": "B",
      "styleProps": {
        "padding": "40px 40px 40px 40px",
        "display": "flex",
        "flex-direction": "row",
        "justify-content": "flex-start",
        "width": "40%",
        "alignItems": "",
        "text-align": "left"
      },
      "stylePropsTab": {
        "padding": "30px 30px 30px 30px"
      },
      "stylePropsMob": {
        "padding": "14px 14px 14px 14px",
        "width": "100%"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "flex",
          "flex-direction": "column",
          "alignItems": "flex-start",
          "justify-content": "flex-start"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      }
    },
    {
      "name": "C",
      "styleProps": {
        "width": "35%",
        "display": "flex",
        "flex-direction": "row",
        "alignItems": "center",
        "justify-content": "center",
        "text-align": "center"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "flex",
          "flex-direction": "row",
          "alignItems": "center",
          "justify-content": "center"
        }
      }
    }
  ]
}